module.exports = __webpack_public_path__ + "Server-Unavailable.TentaclePassive.821f4b7f80c7b6f67feacc02b1fa5fd6.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unavailable.TentaclePassive.png
// module id = 1262
// module chunks = 1